module.exports = __webpack_public_path__ + "static/math-behind-mining-abd1d0c3138ca9c7c59e56237d0caeae.svg";